import {FormikSelect} from '@flexinet/ui-components';
import {FieldProps} from 'formik';
import {SelectProps} from '@mantine/core';

const timezoneOptions = [
    {value: 'America/Los_Angeles', label: 'America/Los_Angeles (Pacific)'},
    {value: 'America/Denver', label: 'America/Denver (Mountain)'},
    {value: 'America/Chicago', label: 'America/Chicago (Central)'},
    {value: 'America/New_York', label: 'America/New_York (Eastern)'},
    {value: 'Europe/London', label: 'Europe/London (GMT)'},
    {value: 'Europe/Berlin', label: 'Europe/Berlin (CET)'},
    {value: 'Asia/Tokyo', label: 'Asia/Tokyo (JST)'},
    {value: 'Asia/Kolkata', label: 'Asia/Kolkata (IST)'},
    {value: 'Australia/Sydney', label: 'Australia/Sydney (AEST)'},
    {value: 'UTC', label: 'UTC'},
];

export const TimezoneDropdown = (props: FieldProps & SelectProps) => {
    return <FormikSelect {...props} data={timezoneOptions} defaultValue='America/Los_Angeles' clearable/>;
};
